/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontaktujte nás`
};

const da_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontakt os`
};

const de_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontaktieren Sie uns`
};

const en_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contact us`
};

const es_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contáctanos`
};

const fr_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contactez-nous`
};

const hu_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Lépj velünk kapcsolatba`
};

const it_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contattaci`
};

const nl_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Neem contact op`
};

const pl_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Skontaktuj się z nami`
};

const pt_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contacte-nos`
};

const sv_contact_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontakta oss`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_contact_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_contact_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_contact_us", locale)
	if (locale === "cs") return cs_contact_contact_us(inputs)
	if (locale === "da") return da_contact_contact_us(inputs)
	if (locale === "de") return de_contact_contact_us(inputs)
	if (locale === "en") return en_contact_contact_us(inputs)
	if (locale === "es") return es_contact_contact_us(inputs)
	if (locale === "fr") return fr_contact_contact_us(inputs)
	if (locale === "hu") return hu_contact_contact_us(inputs)
	if (locale === "it") return it_contact_contact_us(inputs)
	if (locale === "nl") return nl_contact_contact_us(inputs)
	if (locale === "pl") return pl_contact_contact_us(inputs)
	if (locale === "pt") return pt_contact_contact_us(inputs)
	return sv_contact_contact_us(inputs)
};
export { contact_contact_us as "contact.contact_us" }